export const applicationId = "web";
